// Ensure touch and wheel listeners are passive by default to improve scroll performance.
// This helps eliminate "Added non-passive event listener" warnings from third-party libs.
// If a listener explicitly sets { passive: false }, we respect that and do not override.

const defaultPassiveEvents = new Set(['touchstart', 'touchmove', 'touchend', 'touchcancel', 'wheel']) // 'wheel' is safe to be passive in most cases

const originalAddEventListener = EventTarget.prototype.addEventListener
EventTarget.prototype.addEventListener = function (
  type: string,
  listener: EventListenerOrEventListenerObject,
  options?: boolean | AddEventListenerOptions,
) {
  let opts = options as AddEventListenerOptions | undefined

  if (defaultPassiveEvents.has(type)) {
    if (options === undefined) {
      opts = { passive: true }
    } else if (typeof options === 'boolean') {
      // 'options' is actually the 'capture' flag; convert to object and add passive
      opts = { capture: options, passive: true }
    } else if (typeof options === 'object') {
      // Only set passive if not explicitly provided
      if (options.passive === undefined) {
        opts = { ...options, passive: true }
      }
    }
  }

  // Call original with possibly adjusted options
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return originalAddEventListener.call(this, type, listener, opts as any)
}
